import { render, staticRenderFns } from "./PortfolioContainer.vue?vue&type=template&id=12dceb98&scoped=true&"
import script from "./PortfolioContainer.vue?vue&type=script&lang=js&"
export * from "./PortfolioContainer.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioContainer.vue?vue&type=style&index=0&id=12dceb98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dceb98",
  null
  
)

export default component.exports